import localStorageEx from 'bundles/common/utils/localStorageEx';

export type LastSeenDdpInfo = {
  slug: string;
  name: string;
};

export const LAST_SEEN_DDP_KEY = 'lastSeenDDP';

export const getLastSeenDdp = (): LastSeenDdpInfo | undefined =>
  localStorageEx.getItem(LAST_SEEN_DDP_KEY, JSON.parse, undefined);

export const setLastSeenDdp = (info?: LastSeenDdpInfo) => {
  if (!info) localStorageEx.removeItem(LAST_SEEN_DDP_KEY);
  else localStorageEx.setItem(LAST_SEEN_DDP_KEY, info, JSON.stringify);
};
